import { render, staticRenderFns } from "./RoomReservationCalendar.vue?vue&type=template&id=ea6c4ed4&"
import script from "./RoomReservationCalendar.vue?vue&type=script&lang=js&"
export * from "./RoomReservationCalendar.vue?vue&type=script&lang=js&"
import style0 from "./RoomReservationCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports